import { useSelector } from 'react-redux';

import { isSameUTCDay } from '@lootboy/lib/utils/dateAndTime';

import { dailyBoostCountSelector } from '~/redux/selectors';

import useDailyQuestsHook from './useDailyQuestsHook';

const useDailyQuestsCountSelector = () => {
  useDailyQuestsHook();
  const count = useSelector(dailyBoostCountSelector);
  const {
    lastSuccessfulFetch,
    progress: { lastClaimAt },
  } = useSelector((state) => state.intervalProgress);
  if (!lastSuccessfulFetch) {
    return 0;
  }
  const wasClaimedToday = isSameUTCDay(lastClaimAt, new Date());

  return count + !wasClaimedToday;
};

export default useDailyQuestsCountSelector;
